import { render, staticRenderFns } from "./BacRouterLinkOrA.vue?vue&type=template&id=e5d8e58c&"
import script from "./BacRouterLinkOrA.vue?vue&type=script&lang=ts&"
export * from "./BacRouterLinkOrA.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports